export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10691.7ec59670.jpg";